import Navbar from './components/Navbar';
import Ticker from './components/Ticker';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import PkSection from './components/PkSection';
import AbsurdSection from './components/AbsurdSection';
import NewsSection from './components/NewsSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import ScrollTop from './components/ScrollTop';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Ticker />
        <Hero />
        <RankingSection />
        <PkSection />
        <AbsurdSection />
        <NewsSection />
        <FaqSection />
        <AboutSection />
      </main>
      <Footer />
      <ScrollTop />
    </>
  );
}